import { AxiosGlobalFilters } from '../config';

// Espelha o enum `ERelatorioDashboard` do backend (`/v1/usuarios/dashboard/personalizacao`) —
// os valores (não os nomes) são o contrato de fio, então precisam bater exatamente com o C#.
// Mesmos 15 ids usados em `chartsConfig.ts` (`DASHBOARD_CHARTS_CONFIG`), só que numéricos.
export enum ERelatorioDashboard {
  Corretivas = 1,
  OcorrenciasPorPrioridade = 2,
  RankingOcorrencias = 3,
  Preventivas = 4,
  AtividadesPorStatus = 5,
  AvaliacaoAtendimento = 6,
  OcorrenciasPorPrazo = 7,
  AtividadesPorPrazo = 8,
  RankingAtividadesPorUnidade = 9,
  DistribuicaoHorasTecnicas = 10,
  DistribuicaoHorasTecnicasPorSemana = 11,
  RankingHorasPorTecnico = 12,
  OcorrenciasCadastradasSolucionadasPorSemana = 13,
  OcorrenciasPorSistema = 14,
  IgrejasELocais = 15,
}

// Mapeamento 1:1 com os ids de `DASHBOARD_CHARTS_CONFIG` (chartsConfig.ts) — mantido aqui (não lá)
// porque é o contrato de API, não de UI; `useDashboardConfigStorage` importa os dois e faz a ponte.
export const CHART_ID_TO_RELATORIO: Record<string, ERelatorioDashboard> = {
  corretivas: ERelatorioDashboard.Corretivas,
  prioridades: ERelatorioDashboard.OcorrenciasPorPrioridade,
  ranking: ERelatorioDashboard.RankingOcorrencias,
  preventivas: ERelatorioDashboard.Preventivas,
  atividadesStatus: ERelatorioDashboard.AtividadesPorStatus,
  avaliacaoAtendimento: ERelatorioDashboard.AvaliacaoAtendimento,
  ocorrenciasPorPrazo: ERelatorioDashboard.OcorrenciasPorPrazo,
  atividadesPorPrazo: ERelatorioDashboard.AtividadesPorPrazo,
  rankingAtividadesPorUnidade: ERelatorioDashboard.RankingAtividadesPorUnidade,
  distribuicaoHorasTecnicas: ERelatorioDashboard.DistribuicaoHorasTecnicas,
  distribuicaoHorasTecnicasPorSemana: ERelatorioDashboard.DistribuicaoHorasTecnicasPorSemana,
  rankingHorasPorTecnico: ERelatorioDashboard.RankingHorasPorTecnico,
  ocorrenciasCadastradasSolucionadasPorSemana: ERelatorioDashboard.OcorrenciasCadastradasSolucionadasPorSemana,
  ocorrenciasPorSistema: ERelatorioDashboard.OcorrenciasPorSistema,
  igrejasLocais: ERelatorioDashboard.IgrejasELocais,
};

export const RELATORIO_TO_CHART_ID: Record<number, string> = Object.fromEntries(
  Object.entries(CHART_ID_TO_RELATORIO).map(([id, relatorio]) => [relatorio, id]),
);

export interface PersonalizacaoDashboardResponse {
  relatorios: ERelatorioDashboard[];
}

const BASE = '/v1/usuarios/dashboard/personalizacao';

const DashboardPersonalizacaoService = {
  // 204 (usuário nunca personalizou) chega aqui com `data` vazio — normalizamos pra `null` só na
  // camada de cima (`useDashboardConfigQuery`), aqui devolvemos a resposta crua do axios.
  getPersonalizacao: ({ empresaId }: { empresaId: number }) =>
    AxiosGlobalFilters({
      method: 'GET',
      url: BASE,
      params: { empresaId },
      headers: { EmpresaId: empresaId },
    }),

  savePersonalizacao: ({ empresaId, relatorios }: { empresaId: number; relatorios: ERelatorioDashboard[] }) =>
    AxiosGlobalFilters({
      method: 'PUT',
      url: BASE,
      data: { empresaId, relatorios },
      headers: { EmpresaId: empresaId },
    }),
};

export { DashboardPersonalizacaoService };
